import React, { createContext, useContext, useState } from 'react'

interface IDataPayload {
  hotelName: string
  customerName: string
  startDate: Date
  endDate: Date
  cancellationLimit: Date
  bookingId: string
}

interface ICancelBookingData {
  toggleCancelBookingModal: () => void
  setData: (data: IDataPayload) => void
  payloadData: any | undefined
  isOpen: boolean
}

// eslint-disable-next-line
const CancelBookingContext = createContext<ICancelBookingData>({} as ICancelBookingData);

function CancelBookingProvider({
  children,
}: React.PropsWithChildren<object>): JSX.Element {
  const [isOpen, setIsOpen] = useState(false)
  const [payloadData, setPayloadData] = useState<IDataPayload>()

  function toggle(): void {
    setIsOpen(!isOpen)
  }

  function setData(data: any): void {
    setPayloadData(data)
    toggle()
  }

  return (
    // eslint-disable-next-line
    <CancelBookingContext.Provider value={{ isOpen, toggleCancelBookingModal: toggle, payloadData, setData }}>
      {children}
    </CancelBookingContext.Provider>
  )
}

function useCancelBooking(): ICancelBookingData {
  const context = useContext(CancelBookingContext)

  if (!context) {
    throw new Error(
      'useCancelBooking must be used within an CancelBookingProvider',
    )
  }

  return context
}

export { CancelBookingProvider, useCancelBooking }
